import {differenceInDays, isFuture, parseISO} from 'date-fns';
import {formatInTimeZone, toZonedTime} from 'date-fns-tz';
import {TIMEZONE} from '#shared/constants';
import {tiltintStories} from '~/utils/tiltintStories';

/**
 * Full days between two moments in Prague wall-clock time,
 * so SSR (UTC) and the browser get the same result even across a DST change.
 */
function differenceInPragueDays(laterDate: Date, earlierDate: Date): number {
	return differenceInDays(toZonedTime(laterDate, TIMEZONE), toZonedTime(earlierDate, TIMEZONE));
}

export function leafletValidityEndDate(validTo: string): string | null {
	const endDate = parseISO(validTo);

	if (!isFuture(endDate)) {
		return null;
	}

	const {t} = useI18n();
	const daysDiff = differenceInPragueDays(endDate, new Date());
	const genitiveDay = t(`daysOfWeekGenitive.${formatInTimeZone(endDate, TIMEZONE, 'EEEE')}`);
	return daysDiff < 7
		? `Tato nabídka platí do ${genitiveDay}`
		: `Tato nabídka platí ještě ${tiltintStories(daysDiff || 0, 'den', 'dny', 'dní')}`;
}

export function leafletValidityStartDate(validFrom: string, short = false): string | null {
	const startDate = parseISO(validFrom);

	if (!isFuture(startDate)) {
		return null;
	}

	const {t} = useI18n();
	const daysDiff = differenceInPragueDays(startDate, new Date());
	const genitiveDay = t(`daysOfWeekGenitive.${formatInTimeZone(startDate, TIMEZONE, 'EEEE')}`);
	return daysDiff < 4
		? `${short ? 'Od' : 'Platný od'} ${genitiveDay}`
		: `Platný za ${tiltintStories(daysDiff || 0, 'den', 'dny', 'dní')}`;
}
